<ion-header>
  <ion-toolbar>
    <ion-title class="modal-title-with-icon">
      <ion-icon class="modal-title-icon" [src]="getAiSummarizeIconSrc()" aria-hidden="true"></ion-icon>
      <span>AI Summarization</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  
  <ion-list lines="none">
    <ion-item class="input-item">
      <ion-icon name="link-outline" slot="start" color="medium"></ion-icon>
      <ion-input label="Website" labelPlacement="stacked" #websiteInput [(ngModel)]="website" type="text" (ionBlur)="checkWebsiteReliability()"
          (keyup.enter)="submit()" required placeholder="https://..."></ion-input>
    </ion-item>

      <!-- Reliability status badge -->
      <ion-item lines="none" class="reliability-item">
        <ion-label style="display: flex; justify-content: flex-end; align-items: center; width: 100%;">
          <ion-text color="medium" style="font-size: 0.8em; margin-right: 8px;">Scrape Success Rate</ion-text>
          <ion-badge class="rate-status" [color]="getReliabilityColor(websiteReliabilityStatus)" style="margin-right: 4px;">
            {{ websiteReliabilityStatus | titlecase }}
          </ion-badge>
          <ion-icon name="information-circle-outline" color="medium"
              title="Based on our recent attempts, this indicator shows how often we've successfully scraped this site."
              style="font-size: 16px;"></ion-icon>
        </ion-label>
      </ion-item>

      <!-- Optional suggestion list -->
      <div *ngIf="suggestions?.length > 0" class="ion-margin-bottom">
        <ion-item-divider color="light">
          <ion-label>
            <small>Suggested Alternatives</small>
          </ion-label>
        </ion-item-divider>

        <ion-list class="suggestion-list">
          <ion-item *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)"
            class="suggestion" button detail="false">
            <ion-label>
              <h2 class="suggestion-title">
                <span class="fake-link">
                  {{ suggestion.title }}
                </span>
              </h2>
              <p class="suggestion-snippet">{{ suggestion.snippet }}</p>
              <p class="suggestion-displayLink"><small>{{ suggestion.displayLink }}</small></p>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>

    <ion-item class="input-item">
      <ion-icon name="list" slot="start" color="medium"></ion-icon>
      <ion-input label="Max Paragraphs" labelPlacement="stacked" [(ngModel)]="maxParagraphs" type="number" min="1" max="10"></ion-input>
    </ion-item>

    <ion-item class="input-item">
      <ion-icon name="mic" slot="start" color="medium"></ion-icon>
      <ion-select label="Tone" labelPlacement="stacked" [(ngModel)]="responseTone" interface="popover">
          <ion-select-option value="objective">Objective</ion-select-option>
          <ion-select-option value="insightful">Insightful</ion-select-option>
          <ion-select-option value="confident">Confident</ion-select-option>
          <ion-select-option value="empathetic">Empathetic</ion-select-option>
          <ion-select-option value="engaging">Engaging</ion-select-option>
          <ion-select-option value="trolling">Trolling</ion-select-option>
          <ion-select-option *ngFor="let customTone of account?.customTones" [value]="customTone.role">
            {{ customTone.role | titlecase }}
          </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item class="input-item">
      <ion-icon name="pencil" slot="start" color="medium"></ion-icon>
      <ion-textarea label="Additional Directions" labelPlacement="stacked" [(ngModel)]="directions" autoGrow="true" rows="2" placeholder="e.g. Focus on..."></ion-textarea>
    </ion-item>
  </ion-list>

  <div class="ion-padding-top">
    <ion-button class="ai-summarize-button" expand="block" (click)="submit()" [disabled]="!website">
        Summarize with AI
        <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
    </ion-button>
  </div>

</ion-content>